/* ff-* global behaviours: wishlist toggle (local), AJAX add-to-cart on ff product cards */
(() => {
  if (window.__ffInit) return;
  window.__ffInit = true;

  const KEY = 'ff-wishlist';
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } };
  const write = (v) => { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} };

  const paint = (root = document) => {
    const list = read();
    root.querySelectorAll('[data-ff-wish]').forEach((b) => b.setAttribute('aria-pressed', String(list.includes(b.dataset.ffWish))));
  };
  paint();
  document.addEventListener('shopify:section:load', (e) => paint(e.target));

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-ff-wish]');
    if (!btn || !btn.dataset.ffWish) return;
    const list = read();
    const i = list.indexOf(btn.dataset.ffWish);
    i > -1 ? list.splice(i, 1) : list.push(btn.dataset.ffWish);
    write(list);
    paint();
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-ff-add-to-cart]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    btn.disabled = true;
    try {
      const body = new FormData(form);
      const drawer = document.querySelector('cart-drawer');
      if (drawer) body.append('sections', drawer.getSectionsToRender().map((s) => s.id).join(','));
      const res = await fetch(`${window.routes.cart_add_url}.js`, { method: 'POST', body, headers: { Accept: 'application/json' } });
      const state = await res.json();
      if (state.status) throw new Error(state.description || state.message);
      if (drawer) { drawer.renderContents(state); } else { window.location = window.routes.cart_url; }
    } catch (err) {
      form.submit();
    } finally {
      btn.disabled = false;
    }
  });
})();
